import { render, staticRenderFns } from "./CompanyNode.vue?vue&type=template&id=bc84ded6&scoped=true&"
import script from "./CompanyNode.vue?vue&type=script&lang=js&"
export * from "./CompanyNode.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNode.vue?vue&type=style&index=0&id=bc84ded6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc84ded6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDivider,VIcon})
